import React, { useEffect } from 'react';

import { Breadcrumbs, Link } from '@mui/material';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

import {
  breadcrumb,
  breadcrumbsText,
  mypageHeader,
  mypageHeaderTitle,
  mypageWrapper
} from '../../../constants/Location';
import { screenType } from '../../../constants/enum';
import RegisterBasicEditCard from '../../uiParts/RegisterBasicEditCard';
import Sidebar from '../../uiParts/Sidebar';

const styles = {
  breadcrumb,
  breadcrumbsText,
  mypageHeader,
  mypageHeaderTitle,
  mypageWrapper
};

const ClientMypageCompnayEdit: React.FC = () => {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = t('title.client.companyEdit');
  }, []);

  const breadcrumbs = [
    <Link
      underline="hover"
      key="1"
      href="/main/client/mypage/company"
      sx={styles.breadcrumbsText}
    >
      {t('mypage.info')}
    </Link>,
    <Typography key="2" sx={styles.breadcrumbsText}>
      {t('mypage.infoEdit')}
    </Typography>
  ];

  return (
    <>
      <Typography component="div" sx={styles.mypageWrapper}>
        <Sidebar screenType={screenType.client} />
        <Typography component="div" sx={{ width: '100%' }}>
          <Typography sx={styles.mypageHeader} component="div">
            <Typography sx={styles.mypageHeaderTitle}>
              {t('mypage.infoEdit')}
            </Typography>
          </Typography>
          <Breadcrumbs
            separator=">"
            aria-label="breadcrumb"
            sx={[
              styles.breadcrumb,
              {
                '@media screen and (max-width:480px)': {
                  display: 'none'
                }
              }
            ]}
          >
            {breadcrumbs}
          </Breadcrumbs>
          <RegisterBasicEditCard screen={screenType.client} />
        </Typography>
      </Typography>
    </>
  );
};

export default ClientMypageCompnayEdit;
